// services for user api
import axios from 'axios'
// import global settings
import baseConf from '@/Base'
// instance for autentications user
var instance = axios.create({
  baseURL: baseConf.urlApi,
  timeout: 12000
})

const apiTorneo = {}

export function torneoSearch(kword, page=1) {
  // url = url para consulta directa en caso exista, ayuda para navegar por paginas de paginacion
  // consulta al servidor
  return instance.get('/api/torneo/buscar-torneo/?kword=' + kword + '&page=' + page)
}

export function listaObsTorneo(pk) {
  // servicio que devuelve los premios de un torneo por id de un torneo
  // consulta al servidor
  return instance.get('/api/torneo/list-obs/' + pk + '/')
}

export function getTorneo(pk) {
  // servicio que devuelve los datos de un torneo por id
  // consulta al servidor
  return instance.get('/api/torneo/get/' + pk + '/')
}

export function torneosPorCompeticionUsername(username, page) {
  // servicio que que lista torneos por competicion por username
  // username de competition
  return instance.get('/api/torneo/lista/torneos-por-competicion/' + username + '/?page=' + page)
}

export function getCompeticionUsername(username) {
  // servicio que devuelve una competicion por nombre de usuario
  // username=nombre de usuario unico de la competicion
  return instance.get('/api/torneo/competicion/retrive/' + username + '/')
}

export function compeSigueUsuario(page) {
  // servicio que lista competiciones que sigue un usuario
  // consulta al servidor
  return instance.get('/api/compe/listar/sigue-usuario/?page=' + page, {
    headers: {
      'Authorization': 'Token ' + localStorage.getItem('token')
    }
  })
}

export function searchTorneoSigueUsuario(kword, page) {
  // busca torneos que sigue un usuario
  // consulta al servidor
  return instance.get('/api/torneo/search/sigue-usuario/?kword=' + kword + '&page=' + page, {
    headers: {
      'Authorization': 'Token ' + localStorage.getItem('token')
    }
  })
}

export function torneosRanking(page) {
  // servicio que devuelve torneos creados por un usuario
  // consulta al servidor
  return instance.get('/api/torneo/listar/rankig/?page=' + page, {
    headers: {
      'Authorization': 'Token ' + localStorage.getItem('token')
    }
  })
}

export function listaUserCompeticion(page) {
  // servicio que devuelve competiciones de un usuario
  // consulta al servidor
  return instance.get('/api/torneo/competiciones-usuario/?page=' + page, {
    headers: {
      'Authorization': 'Token ' + localStorage.getItem('token')
    }
  })
}

export function generarUsernameCompe() {
  // servicio que devuelve competiciones de un usuario
  // consulta al servidor
  return instance.get('/api/compe/generar-username/', {
    headers: {
      'Authorization': 'Token ' + localStorage.getItem('token')
    }
  })
}

export function verifyUsernameCompe(username) {
  // servicio que verifica si un nombre de usuario esta disponible
  // consulta al servidor
  return instance.get('/api/compe/verify-username/' + username + '/', {
    headers: {
      'Authorization': 'Token ' + localStorage.getItem('token')
    }
  })
}

export function createCompeticion(data) {
  // token de autorizacion
  return instance.post('/api/torneo/competicion/create/', data, {
    headers: {
      'Authorization': 'Token ' + localStorage.getItem('token')
    }
  })
}

export function createTorneo(data) {
  // servicio que crea un torneo
  return instance.post('/api/torneo/torneo/create/', data, {
    headers: {
      'Authorization': 'Token ' + localStorage.getItem('token')
    }
  })
}

export function getTorneoAdmin(pk) {
  // consulta al servidor
  return instance.get('/api/torneo/get-admin/' + pk + '/',{
    headers: {
      'Authorization': 'Token ' + localStorage.getItem('token')
    }
  })
}

export function cambiarImagenTorneo(data) {
  return instance.patch('/api/torneo/imagen/upload/', data, {
    headers: {
      'Authorization': 'Token ' + localStorage.getItem('token'),
      'Content-Type': 'multipart/form-data'
    }
  })
}

export function actualizarDatosTorneo(pk, data) {
  // servicio para actualizar a inscripcion de un equipo a rechaado
  return instance.patch('/api/torneo/update-data/' + pk + '/', data, {
    headers: {
      'Authorization': 'Token ' + localStorage.getItem('token')
    }
  })
}

export function crearPremio(data) {
  // servicio que crea premios de un torneo
  return instance.post('/api/torneo/premios/create/', data, {
    headers: {
      'Authorization': 'Token ' + localStorage.getItem('token')
    }
  })
}

export function listaPremiosTorneo(pk) {
  // servicio que devuelve los premios de un torneo por id de un torneo
  // consulta al servidor
  return instance.get('/api/torneo/award/lista/' + pk + '/')
}

export function deletePremioTorneo(pk, data) {
  // servicio para eliminar un premio de torneo
  return instance.delete('/api/torneo/premios/delete/' + pk + '/', data, {
    headers: {
      'Authorization': 'Token ' + localStorage.getItem('token')
    }
  })
}

export function subirBasesTorneo(data, pk) {
  axios.defaults.headers.common['Content-Type'] = 'multipart/form-data'
  axios.defaults.timeout = 5000
  return instance.patch('/api/torneo/update-data/' + pk + '/', data, {
    headers: {
      'Authorization': 'Token ' + localStorage.getItem('token')
    }
  })
}

export function getCompeticion(pk) {
  // servicio que devuelve una competicion por id
  // consulta al servidor
  return instance.get('/api/torneo/competicion/get/' + pk + '/', {
    headers: {
      'Authorization': 'Token ' + localStorage.getItem('token')
    }
  })
}

export function getCompeticionAdmin(username) {
  // servicio que devuelve una competicion de usuario admin
  return instance.get('/api/torneo/competicion-admin/get/' + username + '/', {
    headers: {
      'Authorization': 'Token ' + localStorage.getItem('token')
    }
  })
}

export function listTorneosByCompetitionAdmin(username, page) {
  // lista torneos de una competicion y usuario admin
  return instance.get('/api/torneo/lista/competicion-admin/' + username + '/?page=' + page, {
    headers: {
      'Authorization': 'Token ' + localStorage.getItem('token')
    }
  })
}

export function cambiarPortadaCompe(data) {
  return instance.patch('/api/compe/portada/upload/', data, {
    headers: {
      'Authorization': 'Token ' + localStorage.getItem('token'),
      'Content-Type': 'multipart/form-data'
    }
  })
}

export function actualizarDatosCompeticion(pk, data) {
  // servicio para actualizar a inscripcion de un equipo a rechaado
  return instance.patch('/api/torneo/competicion/update/' + pk + '/', data, {
    headers: {
      'Authorization': 'Token ' + localStorage.getItem('token')
    }
  })
}

export function cambiarLogoCompe(data) {
  return instance.patch('/api/compe/logo/upload/', data, {
    headers: {
      'Authorization': 'Token ' + localStorage.getItem('token'),
      'Content-Type': 'multipart/form-data'
    }
  })
}

export function createObsTorneo(data) {
  // servicio para eliminar todas las competiciones en papelera
  return instance.post('/api/torneo/add-obs/', data, {
    headers: {
      'Authorization': 'Token ' + localStorage.getItem('token')
    }
  })
}

export function deleteObsTorneo(pk) {
  // servicio para eliminar todas las competiciones en papelera
  return instance.delete('/api/torneo/delete-obs/' + pk + '/', {
    headers: {
      'Authorization': 'Token ' + localStorage.getItem('token')
    }
  })
}

export function shortTorneosPorCompeticion(pk, page) {
  // servicio que lista torneos de una competicion en un array corto
  return instance.get('/api/admin/torneo/short-por-competicion-admin/' + pk + '/?page=' + page, {
    headers: {
      'Authorization': 'Token ' + localStorage.getItem('token')
    }
  })
}

export function torneosPopulares(N) {
  // consulta al servidor N torneos con datos de creador
  return instance.get('/api/torneo/listar/torneo-usuario/' + N + '/')
}

export function  followCompetition(data) {
  return instance.post('/api/seguidor/torneo/create/', data, {
    headers: {
      'Authorization': 'Token ' + localStorage.getItem('token')
    }
  })
}

export function  getUserFollowCompe(usernmae_compe) {
  // consulta si un usuario sigue o no una competicion
  return instance.get('/api/seguidor/user-sigue/' + usernmae_compe + '/', {
    headers: {
      'Authorization': 'Token ' + localStorage.getItem('token')
    }
  })
}

export function  deleteFollowCompetition(data) {
  return instance.post('/api/seguidor/delete-follow/', data, {
    headers: {
      'Authorization': 'Token ' + localStorage.getItem('token')
    }
  })
}

export function  torneosUserHistorial(username, page) {
  // consulta al servidor N torneos con datos de creador
  return instance.get('/api/torneo/user/historial/' + username + '/?page=' + page)
}

export function  torneosPorIdCompeticionAdmin(id_compe, page) {
  // consulta al servidor N torneos con datos de creador
  return instance.get('/api/admin/compe/torneos-by-id/' + id_compe + '/?page=' + page,{
    headers: {
      'Authorization': 'Token ' + localStorage.getItem('token')
    }
  })
}


export function  saveCustomUrlTorneo(data) {
  return instance.post('/api/torneo/url-custom/save-data/', data, {
    headers: {
      'Authorization': 'Token ' + localStorage.getItem('token')
    }
  })
}

export function  generateCustomUrl(pk) {
  // servicio que verifica si un nombre de usuario esta disponible
  // consulta al servidor
  return instance.get('/api/torneo/url-custom/generate/', {
    headers: {
      'Authorization': 'Token ' + localStorage.getItem('token')
    }
  })
}

export function  getTorneoCustomUrl(pk) {
  // recupera el id de una url personalizada
  return instance.get('/api/custom-url/get-admin/' + pk + '/', {
    headers: {
      'Authorization': 'Token ' + localStorage.getItem('token')
    }
  })
}


export function  listTorneoCustomUrl(idCompe, page) {
  // recupera el id de una url personalizada
  return instance.get('/api/torneo/custom-url/list/' + idCompe + '/?page=' + page, {
    headers: {
      'Authorization': 'Token ' + localStorage.getItem('token')
    }
  })
}


export function  getTorneoCustomUrlPublic(pk) {
  // recupera el id de una url personalizada
  return instance.get('/api/custom-url/get-public/' + pk + '/')
}

export function  updateTorneoCustomUrl(pk, data) {
  // recupera el id de una url personalizada
  return instance.patch('/api/custom-url/update-data-admin/' + pk + '/', data, {
    headers: {
      'Authorization': 'Token ' + localStorage.getItem('token')
    }
  })
}


export function  deleteTorneoCustomUrl(pk) {
  // recupera el id de una url personalizada
  return instance.delete('/api/custom-url/delete-data/' + pk + '/', {
    headers: {
      'Authorization': 'Token ' + localStorage.getItem('token')
    }
  })
}

export function  listaTorneosUser(page) {
  // devuelve todos los torneos de un usuario, paginados
  // consulta al servidor
  return instance.get('/api/torneo/user/list-all/?page=' + page, {
    headers: {
      'Authorization': 'Token ' + localStorage.getItem('token')
    }
  })
}

export function  updateLimitePlayersCompe(data) {
  // devuelve todos los torneos de un usuario, paginados
  // consulta al servidor
  return instance.post('/api/compet/limite-players/update/', data, {
    headers: {
      'Authorization': 'Token ' + localStorage.getItem('token')
    }
  })
}

export default apiTorneo